// extracted by mini-css-extract-plugin
module.exports = {"SectionSpacing":"styles_SectionSpacing__CwPhh","SectionSpacingThin":"styles_SectionSpacingThin__doLSB"};